/** @jsxImportSource @emotion/react */
import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Button, Stack } from '@mui/material';
import Header from 'components/Header';
import { add, isThisWeek, sub } from 'date-fns';
import { TXT_BACK, TXT_NAVIGATION_CURRENT, TXT_NEXT } from 'translations';
import { Props } from './types';

const WeekNavigation: FC<Props> = ({ date, setDate }) => {
  const { t } = useTranslation();

  // Allow navigating to next week (to order ahead); disable only once already on next week.
  const isForwardDisabled = isThisWeek(sub(date, { weeks: 1 }));

  const handleBack = () => {
    setDate(sub(date, { weeks: 1 }));
  };

  const handleToCurrent = () => {
    setDate(new Date());
  };

  const handleForward = () => {
    setDate(add(date, { weeks: 1 }));
  };

  return (
    <Header>
      <Stack spacing={2} direction="row" justifyContent="space-evenly">
        <Button
          variant="contained"
          onClick={handleBack}
          startIcon={<ArrowBackIosIcon />}
        >
          {t(TXT_BACK)}
        </Button>

        <Button variant="contained" onClick={handleToCurrent}>
          {t(TXT_NAVIGATION_CURRENT)}
        </Button>

        <Button
          endIcon={<ArrowForwardIosIcon />}
          variant="contained"
          onClick={handleForward}
          disabled={isForwardDisabled}
        >
          {t(TXT_NEXT)}
        </Button>
      </Stack>
    </Header>
  );
};

export default memo(WeekNavigation);
